export default "__VITE_ASSET__BpaufCgZ__"